import React, { FC } from 'react';
import { PageTitle } from '../../../../_metronic/layout/core';
import { View } from './components/View';

const ReportLogPage: FC = () => {
  return (
    <>
      <PageTitle breadcrumbs={[]}>Asistencia</PageTitle>
      <View />
    </>
  );
};

export { ReportLogPage };
